exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-5148901d] {\n    width: 160px;\n}\n", ""]);

// exports
